import { Box, Button, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import Footer from '../Shared/Footer'
import SiteHeader from '../Shared/SiteHeader'

export const NotFound = () => {
  return (
    <div className='page-shell'>
      <SiteHeader />
      <Box className='page-content'>
        <Box
          className='page-container'
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100%',
            textAlign: 'center',
          }}
        >
          <Typography
            aria-hidden
            sx={{
              fontSize: 'clamp(5rem, 18vw, 9rem)',
              fontWeight: 800,
              lineHeight: 1,
              letterSpacing: '-0.04em',
              background: 'linear-gradient(135deg, #ff6b63 0%, #ed1f24 100%)',
              WebkitBackgroundClip: 'text',
              backgroundClip: 'text',
              color: 'transparent',
              textShadow: '0 0 80px rgba(237, 31, 36, 0.25)',
              mb: 2,
            }}
          >
            404
          </Typography>
          <Box className='section-header'>
            <Typography component='h1' className='section-title'>
              Page Not Found
            </Typography>
            <Typography className='section-subtitle'>
              The page you&apos;re looking for doesn&apos;t exist or has been moved.
            </Typography>
          </Box>
          <Button
            component={Link}
            to='/'
            variant='contained'
            className='contact-form__submit'
            sx={{ mt: 4 }}
          >
            Back to Home
          </Button>
        </Box>
      </Box>
      <Footer />
    </div>
  )
}
